import React from "react";
import ModalLayout from "../..";
import "./style.scss";
import Button from "../../../button";

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message?: string;
  onClose: () => void;
  onConfirm: () => void;
  confirmText?: string;
  loading?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  title,
  message,
  onClose,
  onConfirm,
  confirmText = "Confirm",
  loading = false,
}) => {
  const footer = (
    <div className="confirm-modal-actions">
      <div className="spacer" />

      <Button className="ant-btn-tertiary" onClick={onClose} disabled={loading}>
        Cancel
      </Button>

      <Button
        className="ant-btn-secondary"
        type="primary"
        loading={loading} // ✅ AntD loader integrated
        onClick={onConfirm}
      >
        {confirmText}
      </Button>
    </div>
  );

  return (
    <ModalLayout
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      footer={footer}
    >
      <div className="confirm-modal-wrapper">{message && <p>{message}</p>}</div>
    </ModalLayout>
  );
};

export default ConfirmModal;
